import $ from 'jquery';
import get from 'lodash/get';
import removeQueryParam from "../../helpers/remove-query-param";

export default function(){
    const cookieModal = get(window, 'rcProps.trigger.global.cookieModal', false);
    // let checkCountryPref;
    // function ifCountryPrefElExist() {
    //     var element = $('.js-view-country-preferences');
    //
    //     if (element.length) {
    //         $('.js-view-country-preferences').trigger('click');
    //         clearInterval(checkCountryPref);
    //         removeQueryParam('preferences');
    //     }
    // }
    //
    // if (openPreferences === true || openPreferences === 'true') {
    //     checkCountryPref = setInterval(ifCountryPrefElExist, 500);
    //     ifCountryPrefElExist();
    // }
    if (cookieModal === true || cookieModal === 'true') {
        $('.js-customer-care-acc-btn').trigger('click');
        $.modal({
            url: '/r/mobile/CookieBannerModalRevolveMobile.jsp',
            triggerOpen: true,
            type: 'full',
            returnFocus: $('.js-cookie-settings-modal'),
        });
    }
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/footer/amp-cookie.js